import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { Salutation } from '../../../models'

export const MB_SALUTATION_NORMALIZER = new InjectionToken<Converter<any, Salutation[]>>('MbSalutationNormalizer')
